/** Dark-adaptation demonstration: bright → dark, with and without retinitis pigmentosa side by side (D-023). */

import { DARK_DEMO_MINUTES, DARK_DEMO_SECONDS } from './optics/adaptation';

type Listener = () => void;
const listeners = new Set<Listener>();

export const darkDemo = { active: false, start: 0 };

export function onDarkDemo(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function notify(): void {
  for (const fn of [...listeners]) fn();
}

export function startDarkDemo(): void {
  darkDemo.active = true;
  darkDemo.start = performance.now();
  notify();
}

export function stopDarkDemo(): void {
  if (!darkDemo.active) return;
  darkDemo.active = false;
  notify();
}

/** Simulated minutes since the lights went out (time-lapse). */
export function darkDemoMinutes(now = performance.now()): number {
  const t = ((now - darkDemo.start) / (DARK_DEMO_SECONDS * 1000)) * DARK_DEMO_MINUTES;
  return Math.max(0, Math.min(DARK_DEMO_MINUTES, t));
}
